import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-x-hidden" }
const _hoisted_2 = { class: "row g-4 mb-25" }
const _hoisted_3 = { class: "col-xl-8" }
const _hoisted_4 = { class: "card border-0 shadow-none rounded-1 h-100" }
const _hoisted_5 = { class: "card-body p-xl-40" }
const _hoisted_6 = { class: "row g-3 align-items-end" }
const _hoisted_7 = { class: "col-lg-4" }
const _hoisted_8 = { class: "form-label fw-semibold text-title" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { value: 0 }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col-lg-5" }
const _hoisted_13 = { class: "form-label fw-semibold text-title" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "col-lg-3" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_18 = {
  key: 1,
  class: "ri-refresh-line me-1"
}
const _hoisted_19 = { class: "queue-summary-grid mt-4" }
const _hoisted_20 = { class: "queue-summary-card tone-pending" }
const _hoisted_21 = { class: "queue-summary-card tone-completed" }
const _hoisted_22 = { class: "queue-summary-card tone-counter" }
const _hoisted_23 = { class: "col-xl-4" }
const _hoisted_24 = { class: "card border-0 shadow-none rounded-1 h-100" }
const _hoisted_25 = { class: "card-body p-xl-40" }
const _hoisted_26 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_27 = { class: "text-uppercase fs-12 fw-semibold text-muted" }
const _hoisted_28 = { class: "mb-0 mt-1 fw-bold" }
const _hoisted_29 = {
  key: 0,
  class: "completed-mini-list"
}
const _hoisted_30 = {
  key: 1,
  class: "empty-mini-state"
}
const _hoisted_31 = { class: "mb-0" }
const _hoisted_32 = { class: "card border-0 shadow-none rounded-1" }
const _hoisted_33 = { class: "card-body p-xl-40" }
const _hoisted_34 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3" }
const _hoisted_35 = { class: "text-uppercase fs-12 fw-semibold text-muted" }
const _hoisted_36 = { class: "mb-0 mt-1 fw-bold" }
const _hoisted_37 = { class: "text-muted fs-13" }
const _hoisted_38 = {
  key: 0,
  class: "queue-loading-state"
}
const _hoisted_39 = { class: "mb-0 text-muted" }
const _hoisted_40 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_41 = { class: "table queue-table align-middle mb-0" }
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = { class: "queue-pill queue-pill-pending" }
const _hoisted_44 = { class: "fw-semibold text-title" }
const _hoisted_45 = { class: "text-end" }
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  colspan: "9",
  class: "text-center py-5"
}
const _hoisted_50 = { class: "empty-table-state" }
const _hoisted_51 = { class: "fw-bold mb-1" }
const _hoisted_52 = { class: "mb-0 text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, {
        pageTitle: _ctx.$t('pos.waiting_queue'),
        items: _ctx.breadcrumbItems,
        showHome: false
      }, null, 8, ["pageTitle", "items"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("pos.warehouse")), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedWarehouseId) = $event)),
                    class: "form-select h-55 bg-white shadow-none",
                    disabled: _ctx.warehouseLocked
                  }, [
                    _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$t("pos.all_warehouses")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (warehouse) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: warehouse.id,
                        value: warehouse.id
                      }, _toDisplayString(warehouse.name), 9, _hoisted_11))
                    }), 128))
                  ], 8, _hoisted_9), [
                    [
                      _vModelSelect,
                      _ctx.selectedWarehouseId,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("pos.search_queue")), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
                    type: "text",
                    class: "form-control h-55 bg-white shadow-none",
                    placeholder: _ctx.$t('pos.search_waiting_number_invoice_or_customer')
                  }, null, 8, _hoisted_14), [
                    [
                      _vModelText,
                      _ctx.searchQuery,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn style-two w-100 h-55 queue-refresh-btn",
                    disabled: _ctx.isRefreshing,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.refreshQueueData && _ctx.refreshQueueData(...args)))
                  }, [
                    (_ctx.isRefreshing)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                      : (_openBlock(), _createElementBlock("i", _hoisted_18)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("pos.refresh")), 1)
                  ], 8, _hoisted_16)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("article", _hoisted_20, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.pending_tickets")), 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.pendingOrders.length), 1),
                  _createElementVNode("small", null, _toDisplayString(_ctx.$t("pos.waiting_for_counter_handoff")), 1)
                ]),
                _createElementVNode("article", _hoisted_21, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.completed_today")), 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.completedOrders.length), 1),
                  _createElementVNode("small", null, _toDisplayString(_ctx.$t("pos.ready_or_handed_out")), 1)
                ]),
                _createElementVNode("article", _hoisted_22, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.active_counter")), 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.activeWarehouseLabel), 1),
                  _createElementVNode("small", null, _toDisplayString(_ctx.$t("pos.queue_numbers_reset_per_warehouse")), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("pos.pickup_board")), 1),
                  _createElementVNode("h5", _hoisted_28, _toDisplayString(_ctx.$t("pos.recently_completed")), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: _ctx.pickupBoardLink,
                  class: "btn btn-outline-primary btn-sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("pos.open_board")), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              (_ctx.recentCompletedOrders.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentCompletedOrders, (order) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: `completed-${order.id}`,
                        class: "completed-mini-card"
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("small", null, _toDisplayString(_ctx.$t("pos.waiting_no")) + " #" + _toDisplayString(_ctx.getQueueLabel(order)), 1),
                          _createElementVNode("strong", null, _toDisplayString(order.reference_no), 1)
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatDateTime(order.queue_completed_at || order.created_at)), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-notification-off-line" }, null, -1)),
                    _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("pos.no_completed_pickup_orders_for_counter")), 1)
                  ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("pos.counter_queue")), 1),
              _createElementVNode("h4", _hoisted_36, _toDisplayString(_ctx.$t("pos.pending_invoices")), 1)
            ]),
            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("pos.ticket_count", { count: _ctx.filteredPendingOrders.length })), 1)
          ]),
          (_ctx.isInitialLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _cache[4] || (_cache[4] = _createElementVNode("div", {
                  class: "spinner-border text-primary mb-3",
                  role: "status"
                }, null, -1)),
                _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t("pos.loading_waiting_queue")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("table", _hoisted_41, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.waiting_no")), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.invoice")), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.customer")), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.warehouse")), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.items")), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.total")), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.payment_method")), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.created")), 1),
                      _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.$t("common.action")), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPendingOrders, (order) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: order.id
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_43, " #" + _toDisplayString(_ctx.getQueueLabel(order)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_44, _toDisplayString(order.reference_no), 1),
                        _createElementVNode("td", null, _toDisplayString(order.customer_name || _ctx.$t("pos.walk_in_customer")), 1),
                        _createElementVNode("td", null, _toDisplayString(order.warehouse_name || _ctx.$t("pos.main_counter")), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getItemsCount(order)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.stateStore.formatPrice(order.grand_total || 0)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatPaymentMethod(order.paid_by)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDateTime(order.created_at)), 1),
                        _createElementVNode("td", _hoisted_45, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success btn-sm px-3",
                            disabled: _ctx.updatingSaleId === order.id,
                            onClick: ($event: any) => (_ctx.markCompleted(order))
                          }, [
                            (_ctx.updatingSaleId === order.id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_47))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("pos.mark_completed")), 1)
                          ], 8, _hoisted_46)
                        ])
                      ]))
                    }), 128)),
                    (!_ctx.filteredPendingOrders.length)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                          _createElementVNode("td", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ri-inbox-unarchive-line" }, null, -1)),
                              _createElementVNode("h6", _hoisted_51, _toDisplayString(_ctx.$t("pos.no_pending_invoices")), 1),
                              _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t("pos.new_paid_pos_orders_appear")), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}